import { Navigate, Outlet } from 'react-router-dom'
import { useApp } from '../context/AppContext'

const ProtectedRoute = () => {
  const { user, loading } = useApp()

  // ⏳ Evita render mientras valida sesión
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <span>Cargando...</span>
      </div>
    )
  }

  // 🚫 No autenticado → login
  if (!user) {
    return <Navigate to="/login" replace />
  }

  // ✅ Autenticado
  return <Outlet />
}

export default ProtectedRoute
